import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { FontText } from './FontText';

interface BreadcrumbItem {
  name: string;
  url?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  onBreadcrumbClick?: (breadcrumb: BreadcrumbItem) => void;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  items,
  onBreadcrumbClick,
}) => {
  const { theme } = useTheme();

  const handleBreadcrumbClick = (item: BreadcrumbItem) => {
    if (onBreadcrumbClick) {
      onBreadcrumbClick(item);
    }
  };

  const styles: Record<string, React.CSSProperties> = {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      marginBottom: 20,
      flexWrap: 'wrap',
    },
    link: {
      color: theme.colors.textSecondary,
      textDecoration: 'none',
      cursor: 'pointer',
    },
    current: {
      color: theme.colors.text,
    },
    separator: {
      color: theme.colors.textTertiary,
      margin: '0 4px',
    },
  };

  return (
    <nav style={styles.container}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <FontText small style={styles.separator}>
              /
            </FontText>
          )}
          {item.url && index < items.length - 1 ? (
            <Link
              to={item.url}
              style={styles.link}
              onClick={() => handleBreadcrumbClick(item)}
            >
              <FontText small>{item.name}</FontText>
            </Link>
          ) : (
            <FontText
              small
              style={index === items.length - 1 ? styles.current : styles.link}
            >
              {item.name}
            </FontText>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};
